import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeIsDescriptionOpened } from '../../model/configuratorSlice';
import {
    CloseButton,
    ExtendedInfoIcon, InfoIcon,
    PriceIcon, WarningIconOnly,
} from '../../shared/svg/components';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import { CameraShotUtility } from '../../utilities/CameraShotUtility';

const DescriptionPanel = () => {
  const {
      settings, isDescriptionOpened, categoryForDescriptionPanel, featureForDescriptionPanel, rooms, improvementRules,
  } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  return (
    <div className={`description-panel ${isDescriptionOpened ? 'opened' : ''}`}>

      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isDescriptionOpened ? 'opened' : ''}`}
        type="button"
        onClick={() => dispatch(changeIsDescriptionOpened({ isOpen: false }))}
      />
      <div className={`panel ${isDescriptionOpened ? 'opened' : ''}`}>
        <button
          type="button"
          className="close-button"
          onClick={() => dispatch(changeIsDescriptionOpened({ isOpen: false }))}
        >
          <CloseButton />
        </button>
        {(categoryForDescriptionPanel !== null && featureForDescriptionPanel !== null) ? (
          <div className="description-content">
            <div className="container-top">
              <div className="category-title">
                {TranslationUtility.GetFormattedMessageForCategoryName(categoryForDescriptionPanel)}
              </div>
              <div className="feature-price-container">
                <div className="feature-option">
                  {TranslationUtility.GetFormattedMessageForUI('ui-feature-option', 'Opción')}
                  {` ${featureForDescriptionPanel.order}`}
                </div>
                {/* <div className="price">500,00€{featureForDescriptionPanel.price}</div> */}
              </div>
              <div className="image-mask">
                <div className="image-container">
                  <img src={`${settings.thumbs_base_url}/${featureForDescriptionPanel.thumb}`} alt="" />
                </div>
                {/* featureForDescriptionPanel.hasPrice === true ?? <PriceIcon className="price" /> */}
              </div>
              <div className="feature-name">
                {TranslationUtility.GetFormattedMessageForFeatureName(featureForDescriptionPanel)}
              </div>
            </div>
            {(featureForDescriptionPanel.description && featureForDescriptionPanel.description.length > 0) ? (
              <div className="container-bottom">
                <div className="container-content-icon-description-extended">
                  <InfoIcon className="icon" />
                  <div className="description">
                    {TranslationUtility.GetFormattedMessageForFeatureDescription(featureForDescriptionPanel)}
                  </div>
                </div>
              </div>
            ) : null}
            {CameraShotUtility.IsIconOnly(
                rooms, improvementRules, categoryForDescriptionPanel, featureForDescriptionPanel,
            ) ? (
              <div className="container-icon-only-warning">
                <WarningIconOnly className="icon" />
                <div className="container-title-text">
                  <div className="title">
                    {TranslationUtility.GetFormattedMessageForUI('ui-description-panel-attention-message',
                                      'Atención:')}
                  </div>
                  <div className="text">
                    {TranslationUtility.GetFormattedMessageForUI('ui-description-panel-not-represented-message',
                                        'Esta opción no se representa visualmente en la ventana del configurador.')}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

    </div>
  );
};

export default DescriptionPanel;
